import React from 'react'

const TopicTitle = ({number}) => {
  return (
    <h5 className="topic-title">Tópico {number}</h5>
  )
}

export { TopicTitle }
